import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emApplyPure',
  pure: true,
  standalone: false,
})
export class ApplyPurePipe implements PipeTransform {
  public transform<TValue, TReturn, TArgs extends any[]>(
    value: TValue,
    fn: (input: TValue, ...args: TArgs) => TReturn,
    ...extraParams: TArgs
  ): TReturn {
    return fn(value, ...extraParams);
  }
}
